import { select, put } from 'redux-saga/effects';
import { fetch } from '../../../_app/middleware/fetch';
import config from '../../../config';

// ACTIONS

export const TOGGLE_PARENT_CONTINUE = 'TOGGLE_PARENT_CONTINUE';
export const SET_PARENT_UPLOAD_CONTINUE = 'SET_PARENT_UPLOAD_CONTINUE';
export const SET_PARENT_UPLOADING_STATUS = 'SET_PARENT_UPLOADING_STATUS';
export const SET_PARENT_UPLOADING_ERRORS = 'SET_PARENT_UPLOADING_ERRORS';
export const SET_PARENT_UPLOADING_PERCENTAGE =
  'SET_PARENT_UPLOADING_PERCENTAGE';
export const SET_PARENT_UPLOADING_COMPLETE = 'SET_PARENT_UPLOADING_COMPLETE';
export const SET_PARENT_UPLOADING_FILE = 'SET_PARENT_UPLOADING_FILE';
export const SET_PARENT_UPLOADING_FILENAME = 'SET_PARENT_UPLOADING_FILENAME';
export const SET_PARENT_VALIDATED_DATA = 'SET_PARENT_VALIDATED_DATA';
export const SET_PARENT_INSTRUCTIONS_CLICKED =
  'SET_PARENT_INSTRUCTIONS_CLICKED';
export const SET_PARENT_CSV_DOWNLOADED = 'SET_PARENT_CSV_DOWNLOADED';
export const SET_PARENT_UPLOAD_TASKID = 'SET_PARENT_UPLOAD_TASKID';
export const SET_PARENT_TAB_VIEW = 'SET_PARENT_TAB_VIEW';
export const TOGGLE_PARENT_CSV_UPLOAD_STATUS_COMPLETE =
  'TOGGLE_PARENT_CSV_UPLOAD_STATUS_COMPLETE';
export const TOGGLE_PARENT_CSV_HAS_ERRORS = 'TOGGLE_PARENT_CSV_HAS_ERRORS';
export const SET_TOTAL_LOADED = 'SET_TOTAL_LOADED';

// ACTION CREATORS

export function toggleParentContinue(boolean) {
  return { type: TOGGLE_PARENT_CONTINUE, payload: boolean };
}

export function setParentUploadContinue(boolean) {
  return { type: SET_PARENT_UPLOAD_CONTINUE, payload: boolean };
}

export function setParentUploadingStatus(boolean) {
  return { type: SET_PARENT_UPLOADING_STATUS, payload: boolean };
}

export function setParentUploadingErrors(errors) {
  return { type: SET_PARENT_UPLOADING_ERRORS, payload: errors };
}

export function setParentUploadingPercentage(percentage) {
  return { type: SET_PARENT_UPLOADING_PERCENTAGE, payload: percentage };
}

export function setParentUploadingComplete(boolean) {
  return { type: SET_PARENT_UPLOADING_COMPLETE, payload: boolean };
}

export function setParentUploadingFile(file) {
  return { type: SET_PARENT_UPLOADING_FILE, payload: file };
}

export function setParentUploadingFilename(filename) {
  return { type: SET_PARENT_UPLOADING_FILENAME, payload: filename };
}

export function setParentValidatedData(data) {
  return { type: SET_PARENT_VALIDATED_DATA, payload: data };
}

export function setParentInstructionsCLicked() {
  return { type: SET_PARENT_INSTRUCTIONS_CLICKED, payload: true };
}

export function setParentCsvDownloaded() {
  return { type: SET_PARENT_CSV_DOWNLOADED, payload: true };
}

export function setParentTaskId(taskId) {
  return { type: SET_PARENT_UPLOAD_TASKID, payload: taskId };
}

export function setParentTabView(tabView) {
  return { type: SET_PARENT_TAB_VIEW, payload: tabView };
}

export function setTotalParentsLoaded(totalLoaded) {
  return { type: SET_TOTAL_LOADED, payload: totalLoaded }
}

export function toggleParentCsvUploadStatusComplete(boolean) {
  return { type: TOGGLE_PARENT_CSV_UPLOAD_STATUS_COMPLETE, payload: boolean };
}

export function toggleParentCsvHasErrors(boolean) {
  return { type: TOGGLE_PARENT_CSV_HAS_ERRORS, payload: boolean };
}

// SAGAS

export const getParentCSVData = state => state.setupParent.parentCsvData;
export const getRegistrationId = state => state.user.registrationId;

export function* processParentCSV() {
  yield put({ type: SET_PARENT_UPLOAD_CONTINUE, payload: true });
  try {
    const registrationId = yield select(getRegistrationId);
    const fileList = yield select(getParentCSVData);
    const file = fileList.target.files[0];

    yield put({ type: SET_PARENT_UPLOADING_STATUS, payload: true });
    yield put({ type: SET_PARENT_UPLOADING_PERCENTAGE, payload: 50 });
    yield put({ type: SET_PARENT_UPLOADING_FILENAME, payload: file.name });

    const data = new FormData();
    data.append('file', file);

    const action = {
      data,
      method: 'post',
      url: `${
        config.REACT_APP_API_BASE_URL
      }/districts/onboarding/${registrationId}/parents-upload`,
    };

    const response = yield fetch(action);
    const { data: res } = response;

    const { numberOfParentsProcessed, validationErrors } = res;

    // yield put({ type: SET_PARENT_UPLOAD_TASKID, payload: taskId });
    yield put({ type: SET_PARENT_UPLOADING_PERCENTAGE, payload: 100 });
    yield put({ type: SET_PARENT_UPLOADING_COMPLETE, payload: true });

    yield put(setParentUploadingErrors(validationErrors));
    yield put(setTotalParentsLoaded(numberOfParentsProcessed));

  } catch (error) {
    yield put({ type: SET_PARENT_UPLOADING_COMPLETE, payload: true });
    yield put({ type: SET_PARENT_UPLOAD_CONTINUE, payload: true });
    yield put({ type: SET_PARENT_UPLOADING_PERCENTAGE, payload: 0 });
  }
}

// PARENT REDUCER

const initialState = {
  isContinueDisabled: true,
  isUploadComplete: false,
  isUploadContinueDisabled: true,
  isUploading: false,
  uploadingErrors: [],
  uploadingFilename: '',
  uploadingPercentage: 0,
  parentCsvData: [],
  parentUploadingValidatedList: [],
  parentUploadingInstructionsClicked: false,
  parentUploadingTemplateCLicked: false,
  parentUploadTaskId: '',
  parentTabView: 1,
  parentCsvUploadStatusComplete: false,
  parentCsvHasErrors: false,
  totalUploaded: 0,
};

export const setupParentReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_PARENT_CONTINUE:
      return {
        ...state,
        isContinueDisabled: action.payload,
      };
    case SET_PARENT_UPLOAD_CONTINUE:
      return {
        ...state,
        isUploadContinueDisabled: action.payload,
      };
    case SET_PARENT_UPLOADING_STATUS:
      return {
        ...state,
        isUploading: action.payload,
      };
    case SET_PARENT_UPLOADING_ERRORS:
      return {
        ...state,
        uploadingErrors: action.payload,
      };
    case SET_PARENT_UPLOADING_PERCENTAGE:
      return {
        ...state,
        uploadingPercentage: action.payload,
      };
    case SET_PARENT_UPLOADING_COMPLETE:
      return {
        ...state,
        isUploadComplete: action.payload,
      };
    case SET_PARENT_UPLOADING_FILE:
      return {
        ...state,
        parentCsvData: action.payload,
      };
    case SET_PARENT_UPLOADING_FILENAME:
      return {
        ...state,
        uploadingFilename: action.payload,
      };
    case SET_PARENT_VALIDATED_DATA:
      return {
        ...state,
        parentUploadingValidatedList: action.payload,
      };
    case SET_PARENT_INSTRUCTIONS_CLICKED:
      return {
        ...state,
        parentUploadingInstructionsClicked: action.payload,
      };
    case SET_PARENT_CSV_DOWNLOADED:
      return {
        ...state,
        parentUploadingTemplateCLicked: action.payload,
      };
    case SET_PARENT_UPLOAD_TASKID:
      return {
        ...state,
        parentUploadTaskId: action.payload,
      };
    case SET_PARENT_TAB_VIEW:
      return {
        ...state,
        parentTabView: action.payload,
      };
    case TOGGLE_PARENT_CSV_UPLOAD_STATUS_COMPLETE:
      return {
        ...state,
        parentCsvUploadStatusComplete: action.payload,
      };
    case TOGGLE_PARENT_CSV_HAS_ERRORS:
      return {
        ...state,
        parentCsvHasErrors: action.payload,
      };
    case SET_TOTAL_LOADED:
      return {
        ...state,
        totalUploaded: action.payload,
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/setup-parent.duck.js